export default "__VITE_ASSET__0bae7152__"